import { ActiveRobotVersionType, IDataRobotList } from "../types/ses/sesRobotTypes";
import { LangType } from "../types/langTypes";

interface IDeterminingNameAndVersionRobotByIdProps {
	robotList: IDataRobotList[];
	roboId: string;
	translationDictionary: LangType;
}

// определение имени и версии робота по id
const determiningNameAndVersionRobotById = ({ robotList, roboId, translationDictionary }: IDeterminingNameAndVersionRobotByIdProps): string => {
	const idWithoutPostfix = roboId.replace(/(_prod)|(_backup)/g, ""); // id без постфиксов
	const robotName = robotList.find((robotItem) => robotItem.id === idWithoutPostfix)?.name || roboId;
	if (roboId.includes("prod")) return `${robotName} (${translationDictionary["current"] || "prod"})`;
	else if (roboId.includes("backup")) return `${robotName} (${translationDictionary["previous"] || "backup"})`;
	else return `${robotName} (${translationDictionary["future"] || "draft"})`;
};

// получение постфикса с id робота в зависимости от версии робота
const getPostfixWithRobotId = (activeRobotVersion: ActiveRobotVersionType, roboId: string | null): string => {
	if (roboId === null) return "";
	else if (activeRobotVersion === "prod") return roboId + "_prod";
	else if (activeRobotVersion === "backup") return roboId + "_backup";
	else return roboId;
};

export { determiningNameAndVersionRobotById, getPostfixWithRobotId };
